export enum DependencyEnum {
  NoDependency = 'NoDependency',
  Inferior50 = 'Inferior50',
  Inferior99 = 'Inferior99',
  Superior100 = 'Superior100',
  Superior250 = 'Superior250',
  // FOR Grenoble, Créteil, Marseille and Etudiante
  Inferior40 = 'Inferior40',
  Superior40 = 'Superior40'
}
